export {
  clientsApi3,
  useLazyFindClientsByPhoneQuery,
  useLazySearchClientsForRecordQuery,
  useSearchClientsForRecordQuery,
} from './api';
export * from './types';
